import React, { FunctionComponent, Fragment, useState } from 'react';

import Modal from '../../UI/Modal';
import Icon from '../../Icons';

const CvvDescription: FunctionComponent = () => {
  const [modalState, setModalState] = useState(false);

  const toggleModal = () => setModalState((prevState) => !prevState);

  return (
    <Fragment>
      <button type="button" className="pri-link ml5" onClick={toggleModal}>
        What is CVV?
      </button>
      <Modal isOpen={modalState} onClose={toggleModal}>
        <div>
          <p className="fwb">What is CVV?</p>
          <p className="small mt8 mb30 font-light-grey">
            CVV is the 3 or 4 digit number that comes along with all credit and debit cards. it enables cardholders to
            carry out secure online transactions.{' '}
          </p>
          <Icon name="cvvError" path="payment" />
        </div>
      </Modal>
    </Fragment>
  );
};

export default CvvDescription;
